import { formatGetHeaders } from '@configurations/api-configuration';
import { ZoneGateway } from '@scenario/gateways/zoneGateway';
import { Zone } from '@scenario/models/zone.model';
import { environment } from '../../../../../environments/environment';

export class ApiZoneGateway implements ZoneGateway {
  private readonly regionApi = `${environment.backend_url}/api/v1/zone`;
  async retrieveAll(): Promise<Zone[]> {
    try {
      const response = await fetch(`${this.regionApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving regions: ' + error);
    }
  }
}
